import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon27: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#32BBC3"
        d="M2.929 2.929c3.906-3.905 10.238-3.905 14.144 0 3.905 3.905 3.905 10.237 0 14.142-3.906 3.905-10.238 3.905-14.144 0-3.905-3.905-3.905-10.237 0-14.142Zm13.436.707a9 9 0 0 0-12.728 0 9 9 0 0 0 0 12.728 9 9 0 0 0 12.728 0 9 9 0 0 0 0-12.728ZM10.5 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1H10V5.5a.5.5 0 0 1 .5-.5Z"
      />
    </Svg>
  )
}
